import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { Facet } from 'ish-core/models/facet/facet.model';
import { Filter } from 'ish-core/models/filter/filter.model';
import { URLFormParams } from 'ish-core/utils/url-form-params';

/**
 * The Filter Checkbox Component displays a filter group. The items of the filter group are presented as checkboxes.
 *
 * @example
 * <ish-filter-checkbox
 *   [filterElement]="element"
 *   (applyFilter)="applyFilter($event)">
 * </ish-filter-checkbox>
 */
@Component({
  selector: 'ish-filter-checkbox',
  templateUrl: './filter-checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TranslateModule],
})
export class FilterCheckboxComponent {
  readonly filterElement = input.required<Filter>();
  readonly applyFilter = output<{
    searchParameter: URLFormParams;
  }>();

  /**
   * two-way-binding (banana in a box) [(showAll)]="showAllElements[element.name]"
   */
  readonly showAllChange = output<boolean>();
  private showAllValue = false;
  @Input()
  get showAll() {
    return this.showAllValue;
  }
  set showAll(val) {
    this.showAllValue = val;
    this.showAllChange.emit(this.showAllValue);
  }

  filter(facet: Facet) {
    this.applyFilter.emit({ searchParameter: facet.searchParameter });
  }

  /**
   * sort selected to top, increase limitCount to selectedCount on showLess
   */
  getFacets() {
    const facets = [...this.filterElement().facets];

    const selectedFacetsCount = facets.filter(x => x.selected).length;

    const filterElement = this.filterElement();
    return this.showAll || filterElement.limitCount === -1
      ? facets
      : facets
          .sort((a, b) => (a.selected > b.selected ? -1 : a.selected < b.selected ? 1 : 0))
          .slice(0, Math.max(filterElement.limitCount || 0, selectedFacetsCount));
  }
}
